module.exports = __webpack_public_path__ + "static/media/sign-in-background-liess-3.9c643b8d.jpg";